import { makeStyles, TextField } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';

const useStyles = makeStyles({
  root: {
    '&.warning fieldset': {
      borderColor: '#ff9234',
    },
    '&.warning > p, &.warning > label': {
      color: '#ff9234',
    },
  },
});

function NumberInput({
  id,
  label,
  required,
  disabled,
  className,
  fullWidth,
  autoFocus,
  format,
  removeFormatting,
  decimalScale,
  decimalSeparator,
  fixedDecimalScale,
  isAllowed,
  allowNegative,
  value,
  InputProps,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  onKeyPress,
  onKeyUp,
  touched,
  error,
  warning,
  placeholder
}) {
  const styles = useStyles();

  return (
    <NumberFormat
      id={id}
      name={id}
      label={label}
      required={!!required}
      disabled={disabled}
      className={clsx(styles.root, warning && 'warning', className)}
      fullWidth={fullWidth}
      autoFocus={autoFocus}
      autoComplete="off"
      inputProps={{
        autoComplete: 'off',
      }}
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      value={value === undefined ? '' : value}
      InputProps={InputProps}
      customInput={TextField}
      format={format}
      allowNegative={allowNegative}
      removeFormatting={removeFormatting}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      decimalSeparator={decimalSeparator}
      isAllowed={isAllowed}
      onValueChange={(values) => {
        onChange({
          target: {
            id,
            value: values.floatValue,
          },
        });
      }}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onKeyPress={onKeyPress}
      onKeyUp={onKeyUp}
      error={error && touched}
      helperText={warning || (touched && error)}
      placeholder={placeholder}
    />
  );
}

NumberInput.propTypes = {
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyUp: PropTypes.func,
};
NumberInput.defaultProps = {
  fullWidth: true,
};

export default NumberInput;
